<app-hero-v2026
  eyebrow="Resources"
  heading="Brochures and booklets for"
  highlight="Catholic investors"
  lede="Learn how Investing for Catholics applies Catholic values and financial science, whether you are investing for your family or stewarding an organization's assets.">
  <a class="btn btn-primary" routerLink="." fragment="downloads">Browse Downloads</a>
  <a class="btn btn-outline-primary" routerLink="/articles">Read Our Articles</a>
  <app-photo-carousel-v2026 aside [slides]="boothPhotos" [eager]="true"></app-photo-carousel-v2026>
</app-hero-v2026>

  <section class="section resources-page" id="downloads">
    <div class="container">
      <div class="section-head text-center mx-auto">
        <span class="eyebrow">Downloads</span>
        <h2>Guides for every kind of Catholic investor</h2>
        <p>Whether you are investing for your family or serving on a finance council or investment committee, there is a guide here for you.</p>
      </div>

      <div class="row g-4">
        <div class="col-md-6 col-lg-4">
          <article class="res-card h-100">
            <a class="res-cover" href="https://www.ifa.com/pdfs/ifc_brochure.pdf" target="_blank" rel="noopener">
              <img src="https://services.ifa.com/art/images/3646_255x330_c_ifc-brochure-2026_q80.webp" alt="Investing for Catholics Brochure cover" width="255" height="330" loading="lazy">
            </a>
            <div class="res-body">
              <span class="eyebrow">For Individuals &amp; Organizations</span>
              <h3>Investing for Catholics Brochure</h3>
              <p>Our Catholic values, services, principles and investing strategy, including how we work with individual investors, retirement plans, and foundations and endowments.</p>
              <a href="https://www.ifa.com/pdfs/ifc_brochure.pdf" target="_blank" rel="noopener" class="btn btn-primary">Download Brochure</a>
            </div>
          </article>
        </div>

        <div class="col-md-6 col-lg-4">
          <article class="res-card h-100">
            <a class="res-cover" href="https://www.ifa.com/pdfs/do-investment-committees-pick-winners.pdf" target="_blank" rel="noopener">
              <img src="images/do-investment-committees-pick-winners.jpg" alt="Do Investment Committees Pick Winners booklet cover" width="255" height="329" loading="lazy">
            </a>
            <div class="res-body">
              <span class="eyebrow">For Catholic Organizations</span>
              <h3>Do Investment Committees Pick Winners?</h3>
              <p>A summary of studies on manager selection, performance chasing and alternative investments, written for investment committee and finance council members.</p>
              <a href="https://www.ifa.com/pdfs/do-investment-committees-pick-winners.pdf" target="_blank" rel="noopener" class="btn btn-primary">Download Booklet</a>
            </div>
          </article>
        </div>

        <div class="col-md-6 col-lg-4">
          <article class="res-card h-100">
            <a class="res-cover" href="https://www.ifa.com/pdfs/caip_brochure_ifc_23.pdf" target="_blank" rel="noopener">
              <img src="images/caip-brochure-thumb.jpg" alt="Catholic Affiliate Investment Program brochure cover" width="255" height="330" loading="lazy">
            </a>
            <div class="res-body">
              <span class="eyebrow">For Catholic Organizations</span>
              <h3>Catholic Affiliate Investment Program (CAIP)</h3>
              <p>A standardized and flexible investment management program designed for Catholic organizations with multiple locations or affiliated entities.</p>
              <a href="https://www.ifa.com/pdfs/caip_brochure_ifc_23.pdf" target="_blank" rel="noopener" class="btn btn-primary">Download Brochure</a>
            </div>
          </article>
        </div>

        <div class="col-md-6 col-lg-4">
          <article class="res-card h-100">
            <a class="res-cover" href="https://www.ifa.com/pdfs/ifc-target-date-flyer.pdf" target="_blank" rel="noopener">
              <img src="https://services.ifa.com/art/images/3693_255x330_c_ifc-target-date-flyer-cover_q80.webp" alt="Catholic Values Target Date Strategies flyer cover" width="255" height="330" loading="lazy">
            </a>
            <div class="res-body">
              <span class="eyebrow">For Catholic Organizations</span>
              <h3>Catholic Values Target Date Strategies</h3>
              <p>A one-page overview of IFC Target Date Portfolios for plan sponsors: how the glide path works, what is inside, and how to add them to a retirement plan.</p>
              <a href="https://www.ifa.com/pdfs/ifc-target-date-flyer.pdf" target="_blank" rel="noopener" class="btn btn-primary">Download Flyer</a>
            </div>
          </article>
        </div>

        <div class="col-md-6 col-lg-4">
          <article class="res-card h-100">
            <a class="res-cover" href="https://www.ifa.com/pdfs/annual-stewardship-report.pdf" target="_blank" rel="noopener">
              <img src="https://services.ifa.com/art/images/3695_255x330_c_annual-stewardship-report-cover_q80.webp" alt="Investment Stewardship Report cover" width="255" height="330" loading="lazy">
            </a>
            <div class="res-body">
              <span class="eyebrow">For Individuals &amp; Organizations</span>
              <h3>Investment Stewardship Report</h3>
              <p>How the funds in IFC portfolios are screened and how proxy votes and engagement are handled in light of the USCCB Guidelines.</p>
              <a href="https://www.ifa.com/pdfs/annual-stewardship-report.pdf" target="_blank" rel="noopener" class="btn btn-primary">Download Report</a>
            </div>
          </article>
        </div>

        <div class="col-md-6 col-lg-4">
          <article class="res-card h-100">
            <a class="res-cover" href="https://www.ifa.com/pdfs/revisions-usccb-guidelines-2003-to-2021.pdf" target="_blank" rel="noopener">
              <span class="res-cover-placeholder" aria-hidden="true"><small>USCCB</small><strong>Socially Responsible Investment Guidelines</strong></span>
            </a>
            <div class="res-body">
              <span class="eyebrow">For Individuals &amp; Organizations</span>
              <h3>USCCB Investment Guidelines</h3>
              <p>The U.S. Conference of Catholic Bishops' Socially Responsible Investment Guidelines, with the 2021 revisions marked against the 2003 edition.</p>
              <a href="https://www.ifa.com/pdfs/revisions-usccb-guidelines-2003-to-2021.pdf" target="_blank" rel="noopener" class="btn btn-primary">Download Guidelines</a>
            </div>
          </article>
        </div>

        <div class="col-md-6 col-lg-4">
          <article class="res-card h-100">
            <a class="res-cover" href="https://www.ifa.com/pdfs/mensuram_bonam.pdf" target="_blank" rel="noopener">
              <img src="https://services.ifa.com/art/images/3694_255x330_c_mensuram-bonam-cover_q80.webp" alt="Mensuram Bonam document cover" width="255" height="330" loading="lazy">
            </a>
            <div class="res-body">
              <span class="eyebrow">For Individuals &amp; Organizations</span>
              <h3>Mensuram Bonam</h3>
              <p>The Vatican's faith-based measures for Catholic investors, published by the Pontifical Academy of Social Sciences. <a routerLink="/mb">Read IFC's summary</a>.</p>
              <a href="https://www.ifa.com/pdfs/mensuram_bonam.pdf" target="_blank" rel="noopener" class="btn btn-primary">Download Document</a>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>

  
<app-whats-new-articles></app-whats-new-articles>
